import { validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import type { ValidationResult } from 'types';
import type { Link } from './link.entity';

export function validateLinkSelectAcl (): boolean {
    // todo: change to check acl when it is created
    return validateAcls([ 'link_personal_update' ]);
}

export function validateLinkInsertAcl (): boolean {
    // todo: change to check acl when it is created
    return validateAcls([ 'link_personal_update' ]);
}

export function validateLinkUpdateAcl (): boolean {
    // todo: change to check acl when it is created
    return validateAcls([ 'link_personal_update' ]);
}

export function validateLinkDeleteAcl (): boolean {
    // todo: change to check acl when it is created
    return validateAcls([ 'link_personal_update' ]);
}

export function validateLinkAdminAcl (): boolean {
    // todo: change to check acl when it is created
    return validateAcls([ 'link_shared_update' ]);
}

export function validateLink (link: Link, userId: string): ValidationResult {
    if (!link.name) {
        return {
            status: 'error',
            errorMessage: 'Name is required',
        };
    }
    if (!link.group_name) {
        return {
            status: 'error',
            errorMessage: 'Group Name is required',
        };
    }
    if (link.url) {
        try {
            // eslint-disable-next-line unused-imports/no-unused-vars
            const url = new URL(link.url);
        } catch (e) {
            return {
                status: 'error',
                errorMessage: `Url is not valid ${e.message}`,
            };
        }
    } else {
        return {
            status: 'error',
            errorMessage: 'Url is required',
        };
    }


    if (!validateLinkAdminAcl() && link.created_by_id && link.created_by_id !== userId) {
        return {
            status: 'error',
            errorMessage: 'Permission denied: Only admins can edit links they did not create',
        };
    }

    if (!validateLinkAdminAcl() && link.shared === true) {
        return {
            status: 'error',
            errorMessage: 'Permission denied: Only admins can make links shared',
        };
    }

    return {
        status: 'success',
    };
}
